import { mergeMap } from 'rxjs/operators';
import { type as batchType } from 'redux-batch-middleware';

var keyHasType = function keyHasType(type, key) {
  return type === key || typeof key === 'function' && type === key.toString();
};

var keysHasType = function keysHasType(type, keys) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      if (keyHasType(type, key)) {
        return true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return false;
};

export var ofType = function ofType() {
  for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
    keys[_key] = arguments[_key];
  }

  return function (source) {
    return source.pipe(mergeMap(function (action) {
      if (keysHasType(action.type, keys)) {
        return [action];
      }

      if (action.type === batchType) {
        return action.payload.filter(function (subAction) {
          return keysHasType(subAction.type, keys);
        });
      }

      return [];
    }));
  };
};